import React, { useState } from "react";
import { Container, Row, Col, Pagination, Spinner } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import UserItemShop from "../../components/UserShopItem/UserItemShop";
import UserShopProfile from "../../components/UserShopProfile/UserShopProfile";
import BackArrow from "../../components/backArrow";

import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  useGetShopByIdQuery,
  useGetShopItemsQuery,
} from "../../features/shop/shopApiSlice";
import { extractIdFromSlug } from "../../utils/slugUtils";

const LIMIT = 15;



const MinerlAndMiningUserProfile = () => {
  const { shopid: slugId } = useParams();
  const shopid = extractIdFromSlug(slugId);
  const { name } = useSelector((state) => state.user);

  const [page, setPage] = useState(1);
  const [lgShowreport, setLgShowreport] = useState(false);
  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    problem: "",
    desciription: "",
    image: [""],
  });

  // RTK Query
  const { data: shopRes } = useGetShopByIdQuery(shopid, { skip: !shopid });
  const shopData = shopRes?.data?.Shop;

  const { data: itemsRes, isFetching: loading } = useGetShopItemsQuery(
    { shopid, page, limit: LIMIT },
    { skip: !shopid }
  );

  const itemshow = itemsRes?.regular || [];
  const specialoffer = itemsRes?.specialoffer || [];
  const salespromotion = itemsRes?.salespromotion || [];
  const totalPages = itemsRes?.totalPages || 1;
  const newItemdata = [...itemshow, ...specialoffer, ...salespromotion];

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Container className="user-shop-page">
      <div className="user-shop-mobile-back d-lg-none">
        <BackArrow back="/buy-Minerals" />
      </div>
      <Row>
        <Col lg="4" md="3" className="screenHeight user-shop-profile-column">
          <div className="border b-radius height_100">
            {shopData ? (
              <UserShopProfile
                setCreateShop={setCreateShop}
                lgShowreport={lgShowreport}
                setLgShowreport={setLgShowreport}
                shopData={shopData}
                id={slugId}
                shopid={shopid}
                createShop={createShop}
              />
            ) : (
              <Skeleton height={400} />
            )}
          </div>
        </Col>

        <Col lg="8" md="7" className="screenHeight user-shop-items-column">
          <div className="border b-radius">
            <div className="d-none d-lg-block">
              <BackArrow back="/buy-Minerals" />
            </div>

            {loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                <Spinner animation="border" role="status" style={{ color: "#0353A4", width: "48px", height: "48px" }}>
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                <UserItemShop
                  back="/buy-Minerals"
                  shopid={shopid}
                  regular={itemshow}
                  specialoffer={specialoffer}
                  salespromotion={salespromotion}
                  newItemdata={newItemdata}
                  shopData={shopData}
                  isDynamic={true}
                />
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-3 mb-3">
                    <Pagination>
                      <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
                      <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
                      {Array.from({ length: totalPages }, (_, i) => (
                        <Pagination.Item key={i + 1} active={i + 1 === page} onClick={() => handlePageChange(i + 1)}>
                          {i + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalPages} />
                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={page === totalPages} />
                    </Pagination>
                  </div>
                )}
              </>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MinerlAndMiningUserProfile;
